import { ItemsGroup } from "types";

export const transformItemsGroup = (
  itemGroups: ItemsGroup[]
): (ItemsGroup & { children?: ItemsGroup[] })[] => {
  const groupMap: Record<
    ItemsGroup["itemgroupid"],
    ItemsGroup & { children?: ItemsGroup[] }
  > = {};

  for (const group of itemGroups) {
    groupMap[group.itemgroupid] = { ...group, children: [] };
  }

  itemGroups.sort((a, b) => (a.position > b.position ? 1 : -1));

  // Дерево
  const rootGroups: (ItemsGroup & { children?: ItemsGroup[] })[] = [];

  for (const group of itemGroups) {
    if (group.parentid === "0") {
      // Если это корневая группа, добавляем её в корневой массив
      rootGroups.push(groupMap[group.itemgroupid]);
    } else {
      // Если это не корневая группа, добавляем её в массив children родительской группы
      const parentGroup = groupMap[group.parentid];
      if (parentGroup) {
        parentGroup.children = parentGroup.children ?? [];
        parentGroup.children.push(groupMap[group.itemgroupid]);
      }
    }
  }

  return rootGroups;
}; // надо функцию доработать
